import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Grid, Button, Input, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import {downloadFile} from '../../../../common/util/file';
import GroupSelector from './groupSelector';
import VehicleSelector from './vehicleSelector';
import PartNumberCodeTable from './table';
import './pncQueriesList.scss';

const INITIAL_STATE = {
  'partNumberCode': '',
  'partName': '',
  'pncGroup': '',
  'pncVehicle': '',
  'englishDesc': '',
  'generalDesc': '',
};

class PncQueryList extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.searchPncInformation = this.searchPncInformation.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
    this.renderDownloadButton = this.renderDownloadButton.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PartNumberCode, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearPncList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pncListUrl !== this.props.pncListUrl && this.props.pncListUrl) {
      downloadFile(this.props.pncListUrl);
      this.props.clearPncListUrl();
    }
  }

  handleFilterChange(event, target) {
    const {name, value} = target;
    const updatedState = {...this.state};
    updatedState[name] = value.toUpperCase();
    this.setState(updatedState);
  }

  handleSearchClick() {
    this.searchPncInformation();
  }

  getPncQueryParams() {
    const {partNumberCode, partName, pncGroup, pncVehicle, englishDesc, generalDesc} = this.state;
    const {pageSize, pageNumber} = this.props;
    const params = {
      'partNumberCode': partNumberCode,
      'partName': partName,
      'pncGroup': pncGroup,
      'pncVehicle': pncVehicle,
      'limit': pageSize || 20,
      'offset': pageNumber || 0,
      'englishDesc': englishDesc,
      'generalDesc': generalDesc,
    };
    return params;
  }

  searchPncInformation() {
    const urlParams = this.getPncQueryParams();
    this.props.getPartNumberCodeList(urlParams);
  }

  resetFilters() {
    this.props.clearPncList();
    this.setState(INITIAL_STATE);
  }

  getParamExcelParams() {
    const {partNumberCode, partName, pncGroup, pncVehicle} = this.state;
    const params = {
      'partNumberCode': partNumberCode,
      'partName': partName,
      'pncGroup': pncGroup,
      'pncVehicle': pncVehicle,
    };
    return params;
  }

  exportToExcel() {
    const urlParams = this.getParamExcelParams();
    this.props.downloadPncList(urlParams);
  }

  renderDownloadButton() {
    const {downloading, pncList} = this.props;
    if (pncList.length !== 0) {
      return (
        <Button
          onClick={this.exportToExcel}
          primary
          loading={downloading}
          disabled={downloading}
        >
          <Icon name='download' size='large'/>
          Excel
        </Button>
      );
    }
    return null;
  }

  render() {
    const {partNumberCode, partName, englishDesc, generalDesc, pncGroup, pncVehicle} = this.state;
    const {pncList} = this.props;

    return (
      <div className='pnc-queries-list'>
        <Card raised fluid className='title-bar'>
          <Grid columns='equal'>
            <Grid.Row verticalAlign='top'>
              <Grid.Column textAlign='left' width={12}><h2>Mantenimiento de PNC</h2></Grid.Column>
              <Grid.Column textAlign='center'>
                {this.renderDownloadButton()}
              </Grid.Column>
              <Grid.Column textAlign='center'>
                <Button
                  as={Link}
                  to={paths.AddPartNumberCode}
                  primary>
                Agregar
                </Button>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row verticalAlign='middle'>
              <Grid.Column>
                <h5>PNC</h5>
                <Input fluid
                  name='partNumberCode'
                  value={partNumberCode}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column>
                <h5>Nombre</h5>
                <Input fluid
                  name='partName'
                  value={partName}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column>
                <h5>Desc. Inglés</h5>
                <Input fluid
                  name='englishDesc'
                  value={englishDesc}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column>
                <h5>Descripción General</h5>
                <Input fluid
                  name='generalDesc'
                  value={generalDesc}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column>
                <h5>Grupo</h5>
                
                <GroupSelector
                  name = 'pncGroup'
                  value={pncGroup}
                  changeValue={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column>
                <h5>Vehiculo</h5>

                <VehicleSelector
                  name='pncVehicle'
                  value={pncVehicle}
                  changeValue={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='center'>
                <Button
                  type='button'
                  primary
                  className='center-button'
                  onClick={this.handleSearchClick}
                >
                  Buscar
                </Button>
              </Grid.Column>
              <Grid.Column textAlign='center'>
                <Button
                  type='button'
                  secondary
                  className='center-button'
                  onClick={this.resetFilters}
                >
                  Limpiar
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        
        <PartNumberCodeTable
          pncList = {pncList}
          onUpdate = {this.searchPncInformation}
        />
      </div>);
  }
}

const mapStateToProps = (state) => {
  return {
    'pncList': state.allPartNumberCodes.list,
    'pageNumber': state.allPartNumberCodes.offset,
    'pageSize': state.allPartNumberCodes.limit,
    'totalItems': state.allPartNumberCodes.count,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'downloading': state.allPartNumberCodes.downloading,
    'pncListUrl': state.allPartNumberCodes.pncListUrl,
  };
};

const {
  navigateTo,
  clearPncList,
  downloadPncList,
  clearPncListUrl,
  fetchPartsList,
  getPartNumberCodeList,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  clearPncList,
  downloadPncList,
  clearPncListUrl,
  fetchPartsList,
  getPartNumberCodeList,
})(PncQueryList);
